export default "/assets/activity.svg";